<template lang="pug">
  r-form( 
    ref='form'
    submit-text='crear'
    title='crear contrato tipo'
    v-bind='formProps' 
    v-model='hrContractStructure'
    @reset='submitReset'
    @submit='submitCreate'
    )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  import Translator from '@/services/translator'
  //
  import HrContractStructureModel from '@/models/HumanResource/HrContractStructure'
  import HrContractStructureFields from '@/views/HumanResource/HrContractStructure/HrContractStructureFields'
  //
  export default {
    components: {
      RForm,
    },
    computed: {
      formProps() {
        return {
          fields: HrContractStructureFields,
        }
      },
    },
    data() {
      return {
        hrContractStructure: new HrContractStructureModel({
          structure_name: '',
          weekly_hours: '',
          collation: '0',
          mobilization: '0',
          base_salary: '',
        }),
      }
    },
    methods: {
      showCreateError(error) {
        this.showErrorSnackbar(Translator(HrContractStructureModel, error.response.data))
      },
      showCreateSuccess() {
        this.showSuccessSnackbar('Contrato tipo creado exitosamente.')
      },
      submitCreate() {
        return this
          .toWait(true)
          .then(this.toCreate)
          .then(this.toWait)
      },
      submitReset() {
        return this
          .toWait(true)
          .then(this.toReset)
          .then(this.toWait)
      },
      toCreate() {
        return this
          .hrContractStructure
          .toCreate()
          .save()
          .then(this.showCreateSuccess)
          .then(this.toRedirect)
          .catch(this.showCreateError)
      },
      toRedirect() {
        this.$router.push({ name: 'contract-structure-list' })
      },
      toReset() {
        this.hrContractStructure.structure_name = ''
        this.hrContractStructure.weekly_hours = ''
        this.hrContractStructure.collation = '0'
        this.hrContractStructure.mobilization = '0'
        this.hrContractStructure.base_salary = ''
      },
      toWait(value = false) {
        return this
          .$refs
          .form
          .setWait(value)
      },
    },
    mounted() {
      this.setTitle('Contratos tipo')
    },
    beforeRouteEnter(to, from, next) {
      next(ctx => {
        if (!ctx.$can('VIEW_ALL_HOLIDAY')) ctx.$router.push('/')
      })
    },
  }
</script>
